// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Recharts = require("recharts");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var AxisData$ReactHooksTemplate = require("./axisData.res.js");
var Recharts$ReactHooksTemplate = require("../common/Recharts.res.js");
var DataWindow$ReactHooksTemplate = require("./dataWindow.res.js");
var ChartComponentColor$ReactHooksTemplate = require("./chartComponentColor.res.js");
var GenericChartAttribute$ReactHooksTemplate = require("./genericChartAttribute.res.js");

function AreaChartComponent(props) {
  var chartAttribute = props.chartAttribute;
  var renderLegend = function (value, param) {
    return JsxRuntime.jsx("span", {
                children: value,
                className: "text-xs"
              });
  };
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(Recharts.ResponsiveContainer, {
                    children: JsxRuntime.jsxs(Recharts.AreaChart, {
                          data: GenericChartAttribute$ReactHooksTemplate.data(chartAttribute),
                          margin: Caml_option.some(Recharts$ReactHooksTemplate.Margin.make(20, 50, 0, 0)),
                          children: [
                            JsxRuntime.jsx(Recharts.ReferenceLine, {
                                  y: 0,
                                  stroke: "#ccc"
                                }),
                            JsxRuntime.jsx(Recharts.XAxis, {
                                  minTickGap: 1,
                                  dataKey: AxisData$ReactHooksTemplate.key(GenericChartAttribute$ReactHooksTemplate.xAxis(chartAttribute)),
                                  tickLine: false,
                                  axisLine: false,
                                  tick: Caml_option.some(Recharts$ReactHooksTemplate.Tick.make(12, undefined, undefined)("middle", undefined, true)),
                                  tickMargin: 10
                                }),
                            JsxRuntime.jsx(Recharts.YAxis, {
                                  tick: Caml_option.some(Recharts$ReactHooksTemplate.Tick.make(12, undefined, undefined)("end", 10, true)),
                                  tickLine: false,
                                  axisLine: false,
                                  tickMargin: 10
                                }),
                            GenericChartAttribute$ReactHooksTemplate.enableDataWindow(chartAttribute) ? DataWindow$ReactHooksTemplate.show(chartAttribute, props.enlarged, props.containerWidth) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                            $$Array.of_list(Belt_List.mapWithIndex(GenericChartAttribute$ReactHooksTemplate.yAxis(chartAttribute), (function (i, xs) {
                                        return JsxRuntime.jsx(Recharts.Area, {
                                                    type: "monotone",
                                                    dataKey: AxisData$ReactHooksTemplate.key(xs),
                                                    stroke: ChartComponentColor$ReactHooksTemplate.getColorById(i, GenericChartAttribute$ReactHooksTemplate.colors(chartAttribute)),
                                                    strokeWidth: 3.0,
                                                    fill: ChartComponentColor$ReactHooksTemplate.getColorById(i, GenericChartAttribute$ReactHooksTemplate.colors(chartAttribute)),
                                                    children: Caml_option.some(JsxRuntime.jsx(Recharts.LabelList, {
                                                              dataKey: AxisData$ReactHooksTemplate.key(xs),
                                                              position: "top",
                                                              fill: "black",
                                                              fontSize: 12
                                                            }))
                                                  }, String(i));
                                      }))),
                            JsxRuntime.jsx(Recharts.Tooltip, {
                                  contentStyle: {
                                    fontSize: "10pt"
                                  }
                                }),
                            JsxRuntime.jsx(Recharts.Legend, {
                                  formatter: renderLegend
                                })
                          ]
                        })
                  }),
              className: " w-full " + props.chartHeight + " p-4 "
            });
}

var make = AreaChartComponent;

exports.make = make;
/* recharts Not a pure module */
